module.exports = __webpack_public_path__ + "static/media/HEELINGS.67166436.gif";